import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const getTabletGrid = (props) => {
  const grid = ['header header', 'media content', 'cta cta'];
  if (!props.hasCta) grid.pop();
  return grid.map((item) => `'${item}'`).join(' ');
};

const getDesktopGrid = (props) => {
  const grid =
    props.layout === 'Media Right'
      ? ['header media', 'content media', 'cta media']
      : ['media header', 'media content', 'media cta'];
  return grid.map((item) => `'${item}'`).join(' ');
};

const getDesktopGridCols = (props) => {
  const gridCols =
    props.layout === 'Media Right'
      ? '1fr 1.5fr'
      : '1.5fr 1fr'
  return gridCols;
};

export const StyledSuperBlock = styled.article`
  margin-top: 2rem;

  h2 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .styled-content__intro-p {
    font-size: 18px;
    font-weight: 300;
  }

  .btn-list {
    margin-top: 1.5rem;
    justify-content: space-between!important;
    flex-direction: row;

    a {
      width: 48%;
      margin: 0!important;
      font-size: 0.85rem;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    h2 {
      font-size: 2.5rem;
    }

    .styled-content__intro-p {
      font-size: 20px;
    }

    margin-top: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${themeGet('scale.scaleUp04')};
    align-items: center;
    grid-template-areas: ${getTabletGrid};

    .btn-list {
      justify-content: left!important;

      a {
        width: auto;
        margin-right: 12px!important;
        margin-left: 12px!important;
        font-size: 16px;

        &:first-child {
          margin-left: 0!important;
        }
      }
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    grid-template-columns:  ${getDesktopGridCols};
    margin: 6rem 11rem 0;
    grid-column-gap: ${themeGet('scale.scaleUp14')};
    grid-template-areas: ${getDesktopGrid};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1580px) {
    margin: 6rem 5rem 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1580px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const StyledMedia = styled.figure`
  grid-area: media;
  margin-bottom: ${themeGet('scale.scaleUp03')};
  overflow: hidden;
  box-shadow: ${(props) =>
    props.mediaType === 'CodeExample'
      ? '0 0 1px 0 #a8b9d5, 0 7px 11px -4px rgba(0, 23, 62, 0.2)'
      : null};

  @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
    .gatsby-image-wrapper {
      max-height: 270px;
      img {
        object-fit: contain !important;
      }
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-bottom: 0;
  }
`;

export const StyledContent = styled.div`
  grid-area: content;

  p {
    font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .styled-content__intro {
    padding: 0 2rem;
  }  

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    .styled-content__intro {
      padding: 0;
    }
  }
`;


export const StyledTestimonialContainer = styled.div`
  background: ${themeGet('color.colorBlueLightest')};
  margin-top: 3rem;
  padding: 2rem;

  div {
    border-left: 2px solid #3368FA;    
    padding-left: 1.5rem;
    color: #4B5671;    

    img {
      margin-bottom: 1.5rem;
    }

    .testimonial__copy {
      line-height: 1.5rem;
      font-size: 1rem;
      font-weight: 300;
      text-indent: -8px;
    }

    .testimonial__client-name {
      font-weight: 500;
      margin-top:2rem;
      font-size: 1rem;
      margin-bottom: 0;      
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-top: 5rem;
    background: transparent;
    padding: 0;

    div {
      padding-left: 2.5rem;

      .testimonial__client-name {
        margin-bottom: 20px;
      }
    }
  }
`